import { render, staticRenderFns } from "./goodsRecord.vue?vue&type=template&id=14fe4c1d"
import script from "./goodsRecord.vue?vue&type=script&lang=js"
export * from "./goodsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports